<template>
	<div class="app-main">
		<el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="10">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
			<el-col :span="4">
				<div class="app-main-time">
					<el-progress type="circle" :width="45" :percentage="100" :format="formatDay"></el-progress>
					<el-progress type="circle" :width="45" :percentage="percentHours" :format="formatHours"
						color="#67C23A">
					</el-progress>
					<el-progress type="circle" :width="45" :percentage="percentMinutes" :format="formatMins"
						color="#E6A23C">
					</el-progress>
					<el-progress type="circle" :width="45" :percentage="percentSeconds" :format="formatSec"
						color="#F56C6C">
					</el-progress>
				</div>
			</el-col>
			<el-col :span="10" class="app-main-header-btns">
				<el-button size="small" type="primary" @click="handleAdd">保存 </el-button>
				<el-button size="small" type="primary" @click="handleSub">提交 </el-button>
				<el-button size="small" type="primary" @click="$router.back(-1)">返回 </el-button>
			</el-col>
		</el-row>

		<el-row class="mg-b5">
			<el-col :span="24">
				<el-card class="box-card mg-b5" v-if="xjOrder!=null">
					<el-descriptions :column="4" :border="true" :colon="false" size="mini">
						<el-descriptions-item labelClassName="my-descriptions-label" label="报价截止时间">
							{{xjOrder.bjJzTime}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="询价单号">
							{{xjOrder.xjOrder}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="发起单位">
							{{xjOrder.unitName}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="询价单标题1">
							{{xjOrder.title}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="业务实体">
							{{xjOrder.ywSt}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="单据类型">
							{{xjOrder.djType}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="询价方式">
							{{xjOrder.xjFs}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="竞价方向">
							{{xjOrder.biddingFx}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="公开规则">
							{{xjOrder.openRule}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="竞价排名">
							{{xjOrder.biddingSort}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="状态">
							{{xjOrder.status}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="轮次">
							{{xjOrder.rounds}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="货币种类">
							{{xjOrder.currency}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="是否含税">
							{{xjOrder.isHs}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="发布日期">
							{{xjOrder.fbTime}}
						</el-descriptions-item>
						<el-descriptions-item labelClassName="my-descriptions-label" label="备注">
							{{xjOrder.remark}}
						</el-descriptions-item>
					</el-descriptions>
				</el-card>
			</el-col>
			<el-col :span="24">
				<el-card class="box-card">
					<el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle"
						:height="PAGESIZE.h-280">
						<el-table-column type="index" width="40" align="left" fixed="left">
						</el-table-column>
						<el-table-column prop="wzCode" label="物资编码" fixed="left" :show-overflow-tooltip="true"
							width="120">
						</el-table-column>
						<el-table-column prop="wzName" label="物资名称" fixed="left" :show-overflow-tooltip="true"
							width="120">
						</el-table-column>
						<el-table-column prop="wzSspce" label="规格" :show-overflow-tooltip="true" width="120">
						</el-table-column>
						<el-table-column prop="wzModel" label="型号" :show-overflow-tooltip="true" width="120">
						</el-table-column>
						<el-table-column prop="bcExplain" label="补充说明" :show-overflow-tooltip="true" width="120">
						</el-table-column>
						<el-table-column prop="jyBrand" label="建议品牌" align="center" :show-overflow-tooltip="true"
							width="100">
						</el-table-column>
						<el-table-column prop="brand" label="品牌" :show-overflow-tooltip="true" width="120">
							<template slot-scope="scope">
								<el-input size="mini" v-model="scope.row.brand" />
							</template>
						</el-table-column>
						<el-table-column prop="status" label="状态" width="80" align="center" :formatter="formatStatus">
						</el-table-column>
						<el-table-column prop="price" label="单价(元)" width="120">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.price" style="width: 100%;" size="mini"
									controls-position="right">
								</el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="isFq" label="是否放弃" align="center" width="90">
							<template slot-scope="scope">
								<el-checkbox size="mini" v-model="scope.row.isFq" true-label="是" false-label="否">
								</el-checkbox>
							</template>
						</el-table-column>
						<el-table-column prop="isConcatTax" label="是否含税" align="center" width="90">
							<template slot-scope="scope">
								<el-checkbox size="mini" v-model="scope.row.isConcatTax" true-label="是" false-label="否">
								</el-checkbox>
							</template>
						</el-table-column>
						<el-table-column prop="taxRate" label="税率" align="center" width="70">
						</el-table-column>
						<el-table-column prop="num" label="需求数量" align="center" width="100">
						</el-table-column>
						<el-table-column prop="unit" label="单位" align="center" width="70">
						</el-table-column>
						<el-table-column prop="xqDate" label="需求日期" width="120">
						</el-table-column>
						<el-table-column label="供应商附件" width="95">
							<template slot-scope="scope">
								<el-tag v-if="scope.row.gysSrc==undefined" type="info">无附件
								</el-tag>
								<el-link v-else :underline="false" :href="baseURL+scope.row.gysSrc" target="_blank">
									<el-tag type="success">查看附件</el-tag>
								</el-link>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="clJhDate" label="承诺交货日期" width="145">
							<template slot-scope="scope">
								<el-date-picker type="date" size="mini" v-model="scope.row.clJhDate"
									value-format="yyyy-MM-dd">
								</el-date-picker>
							</template>
						</el-table-column> -->
						<el-table-column prop="ghZq" label="供货周期" width="120">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.ghZq" style="width: 100%;" size="mini"
									controls-position="right">
								</el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="bjExplain" label="报价说明" width="140">
							<template slot-scope="scope">
								<el-input size="mini" v-model="scope.row.bjExplain" />
							</template>
						</el-table-column>
						<el-table-column prop="minCgl" label="最小采购量" width="120">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.minCgl" style="width: 100%;" size="mini"
									controls-position="right">
								</el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="minBzl" label="最小包装量" :show-overflow-tooltip="true" width="120">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.minBzl" style="width: 100%;" size="mini"
									controls-position="right">
								</el-input-number>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="isXqYp" label="需要样品" align="center" width="90">
						</el-table-column> -->
						<el-table-column label="询价单附件" width="95">
							<template slot-scope="scope">
								<el-tag v-if="scope.row.src==undefined" type="info">无附件
								</el-tag>
								<el-link v-else :underline="false" :href="baseURL+scope.row.src" target="_blank">
									<el-tag type="success">查看附件</el-tag>
								</el-link>
							</template>
						</el-table-column>

					</el-table>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {
		exportInquiryDetail,
	} from '@/api/srm/inquiryDetail.js'
	import {
		inquiryById
	} from '@/api/srm/inquiry.js'
	import {
		addInquiryDetailUser,
		inquiryDetailUserList
	} from '@/api/srm/inquiryDetailUser.js'

	export default {
		name: "InquiryBj",
		computed: {
			PAGESIZE:function(){
				return this.$store.getters['app/sizeInfo'];
			},
			percentHours:function(){
				if(Math.abs(this.hours)>0){
					return parseInt(Math.abs(this.hours)/24*100)
				}else{
					return 0
				}
			},
			percentMinutes:function(){
				if(Math.abs(this.minutes)>0){
					return parseInt(Math.abs(this.minutes)/60*100)
				}else{
					return 0
				}
			},
			percentSeconds:function(){
				if(Math.abs(this.seconds)>0){
					return parseInt(Math.abs(this.seconds)/60*100)
				}else{
					return 0
				}
			},
		},
		data() {
			return {
				timer: null,
				title: "",
				tableData: [],
				form: {},
				loadingInstance: undefined,
				openDialog: false,
				xjOrder: null,
				count: 0,
				fileName: '',
				dayDiff: 0,
				hours: 0,
				minutes: 0,
				seconds: 0,
				hId: this.$route.query.hId,
				rounds: this.$route.query.rounds,
				quertInfo: {
					page: 1, //当前页码
					limit: 2000, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						hId: this.$route.query.hId,
						userId: this.$store.getters['user/user'].id,
					}
				},
			};
		},
		created() {
			this.getList();
			this.getInquiryById();
		},
		beforeDestroy() {
			clearInterval(this.timer);
		},
		destroyed() {
			if (this.timer) {
				clearInterval(this.timer); //关闭
			}
		},
		mounted() {
			let _this = this;
			_this.$once('hook:beforeDestroy', () => {
				clearInterval(_this.timer);
			})
		},
		methods: {
			getInquiryById() {
				let _this = this;
				inquiryById({
					id: _this.$route.query.hId
				}).then(response => {
					if (response.data.code === 0) {
						_this.xjOrder = response.data.data;
						_this.timer = setInterval(function() {
							_this.timeFn(_this.xjOrder.bjJzTime);
						}, 1000);
					}
				});
			},
			async getList() {
				let _this = this;
				const {
					data: res
				} = await inquiryDetailUserList({
					hId: _this.hId,
					rounds: _this.rounds,
					userId: _this.$store.getters['user/user'].id,
				})
				if (res.code == 0) {
					_this.tableData = res.data;
					_this.count = res.count;
				}
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					orgCode: undefined,
					orgName: undefined,
					wzCode: undefined,
					wzName: undefined,
					wzClassCode: undefined,
					wzSspce: undefined,
					wzModel: undefined,
					bcExplain: undefined,
					paramPz: undefined,
					jobNumber: undefined,
					bomPieceNumber: undefined,
					fixedPrice: undefined,
					isConcatTax: undefined,
					taxRate: undefined,
					num: undefined,
					unit: undefined,
					xqDate: undefined,
					// isXqYp: undefined,
					src: undefined,
					createTime: undefined,
					createUser: this.$store.getters['user/user'].id,
					status: 0,
					hId: this.$route.query.hId,
				}
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			handleAdd: function() {
				let _this = this;
				let b = false;
				for (let item of _this.tableData) {
					item.detailId = item.id;
					item.hId = _this.hId;
					item.rounds = _this.rounds;
					item.userId = _this.$store.getters['user/user'].id;
					if (item.price != undefined) {
						b = true;
					}
				}
				if (!b) {
					_this.$warn("至少一个报价");
					return false;
				}
				addInquiryDetailUser({
					jsons: JSON.stringify(_this.tableData)
				}).then(response => {
					if (response.data.code === 0) {
						_this.getList();
						_this.$success(response.data.msg);
					} else {
						_this.$fail(response.data.msg);
					}
				});

			},
			handleEdit: function(row) {
				this.reset();
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				this.openDialog = true;
			},

			handleExport: function() {
				let _this = this;
				_this.confirm({
					text: '导出当前页，还是全部导出',
					but1: '全部导出',
					but2: '当前页',
					type: '',
					fn: function() {
						let param = JSON.parse(JSON.stringify(_this.quertInfo));
						param.page = 0;
						exportInquiryDetail(param).then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					cancel: function() {
						exportInquiryDetail(_this.quertInfo).then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
				});
			},
			handleAvatarExcel(res, file) {
				if (res.code == 0) {
					this.getList();
				}
				this.loadingInstance.close();
				this.$success(res.msg);
			},
			beforeExcel(file) {
				// 判断文件后缀
				let type = file.name.substring(file.name.lastIndexOf('.') + 1);
				if (!(type == "xls" || type == "xlsx")) {
					this.$fail('请导入Excel文件');
					return false;
				}

				const isLt2M = file.size / 1024 / 1024 <= 1;
				if (!isLt2M) {
					this.$fail('导入Excel不能超过 1MB!');
					return false;
				}
				this.loadingInstance = this.Loading({
					text: '导入中请等待...'
				});
			},
			formatStatus: function(row) {
				return row.status == 0 ? '启用' : '禁用';
			},
			handleAvatarSuccess(res, file) {
				if (res.code == 0) {
					this.$success(res.msg);
					if (this.form.src != "" && this.form.src != undefined) {
						//如果修改附件 则删除原来的附件
						if (this.form.src != res.data.url) {
							this.delFile(this.form.src);
						}
					}
					this.form.src = res.data.url;
				}
			},
			beforeAvatarUpload(file) {
				//      let type = file.name.substring(file.name.lastIndexOf('.') + 1) //判断文件后缀
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$fail('上传附件大小不能超过 2MB!');
				}
				return isLt2M;
			},
			//提交
			handleSub: function() {
				let _this = this;
				addInquiryUser({
					inquiryId: _this.$route.query.hId,
					userId: _this.$store.getters['user/user'].id,
				}).then(response => {
					if (response.data.code === 0) {
						_this.$success(response.data.msg);
					} else {
						_this.$fail(response.data.msg);
					}
				});
			},
			formatDay: function(e) {
				return this.dayDiff + "天";
			},
			formatHours: function(e) {
				return this.hours + "时";
			},
			formatMins: function(e) {
				return this.minutes + "分";
			},
			formatSec: function(e) {
				return this.seconds + "秒";
			},
			timeFn: function(d1) { //di作为一个变量传进来
				let _this = this;
				//如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
				let dateBegin = new Date(d1.replace(/-/g, "/")); //将-转化为/，使用new Date
				let dateEnd = new Date(); //获取当前时间
				let dateDiff = dateBegin.getTime() - dateEnd.getTime(); //时间差的毫秒数
				_this.dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
				let leave1 = dateDiff % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
				_this.hours = Math.floor(leave1 / (3600 * 1000)) //计算出小时数
				//计算相差分钟数
				let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
				_this.minutes = Math.floor(leave2 / (60 * 1000)) //计算相差分钟数
				//计算相差秒数
				let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
				_this.seconds = Math.round(leave3 / 1000)
			}


		}
	};
</script>
<style scoped="scoped">
	.app-main-time {
		display: flex;
		flex-direction: row;
		text-align: center;
		justify-content: space-between;
	}

	.el-input-number ::v-deep .el-input__inner {
		padding-left: 5px;
		padding-right: 30px;
	}

	.el-input--mini ::v-deep .el-input__icon {
		line-height: 28px;
	}
</style>
